import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ManageRefundsDisputes from './ManageRefundsDisputes';

function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Refunds & Disputes | Admin',
    component: (
      <AdminLayout>
        <ManageRefundsDisputes />
      </AdminLayout>
    ),
  };
}

export default action;
